import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './langs/en/translation.json';

i18next.use(initReactI18next).init({
  lng: 'en', // if we will use a language detector, we don´t need this option
  debug: true,
  resources: {
    en: {
      translation,
    },
  },
});
